(function () {
    angular.module('components.youtube', [
        'ngResource',
        'ngSanitize',
        'foundation.core',
        'foundation.mediaquery'
    ])
        .factory('youtubeService', youtubeService)
        .filter('youtubeIdToEmbedUrl', youtubeIdToEmbedUrl)
        .directive('youtubeVideo', youtubeVideo);

    youtubeService.$inject = ['$resource', '$window', '$rootScope', 'FoundationApi', '$q']
    function youtubeService($resource, $window, $rootScope, foundationApi, $q) {
        var activeId;
        var youtube = this;

        var defaults = {
            callback: 'signedInWithGooglePlus',
            cookiepolicy: 'single_host_origin',
            requestvisibleactions: 'https://schemas.google.com/AddActivity',
            scope: 'https://www.googleapis.com/auth/plus.login https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/youtube.upload https://www.googleapis.com/auth/youtube',
            height: 'standard',
            width: 'wide',
            state: '',
            showprivacy: false,
            videoTitle: "Upload a Video",
            clientid: "408412744546-d3unfrbr9i436ib36f890g9jioia8a4q.apps.googleusercontent.com"
        };

        var services = {
            api: {
                uploadVideo: $resource('/api/youtube/{id}', { id: '@id' })
            },
            loadJavascriptApi: function () {
                var deferred = $q.defer();
                if (youtube.apiLoaded) {
                    deferred.resolve(true);
                }
                else {
                    $window.___gcfg = {
                        lang: 'en'
                    };
                    var po = document.createElement('script');
                    po.type = 'text/javascript';
                    po.async = true;
                    po.src = 'https://apis.google.com/js/client:plusone.js';
                    var s = document.getElementsByTagName('script')[0];
                    s.parentNode.insertBefore(po, s);
                    $window.signedInWithGooglePlus = function () { };
                    po.onload = function () {
                        var anchor = document.createElement('span');
                        anchor.id = "signInButton";
                        document.getElementsByTagName("body")[0].appendChild(anchor);
                        deferred.resolve(true)
                        youtube.apiLoaded = true;
                    };
                    var timer = setTimeout(function () {
                        deferred.reject({
                            message: 'Request for api has timed out.'
                        });
                    }, 30000);
                }
                return deferred.promise;
            },
            login: function() {
                var deferred = $q.defer();
                $window.signedInWithGooglePlus = function (authResult) {
                    if (authResult && authResult.access_token) {
                        youtube.accessToken = authResult.access_token;
                        deferred.resolve(authResult.access_token);
                    } else {
                        deferred.reject(authResult);
                    }
                };
                if (youtube.accessToken !== undefined) {
                    deferred.resolve(youtube.accessToken);
                    return deferred.promise;
                }
                services.loadJavascriptApi().then(function () {
                    $window.gapi.auth.signIn(defaults)
                }).catch(function (response) {
                    deferred.reject(response);
                });
                return deferred.promise;
            },
            getChannels: function () {
                var deferred = $q.defer();
                services.login().then(function () {
                    $window.gapi.client.request({
                        path: '/youtube/v3/channels',
                        params: {
                            part: 'snippet',
                            mine: true
                        },
                        callback: function (response) {
                            if (response.error) {
                                console.log(response.error.message);
                            }
                        }.bind(this)
                    });
                });
                return deferred.promise;
            },
            uploadVideo: function (file, metaData) {
                var progress = {}
                var deferred = $q.defer();
                services.login().then(function (accessToken) {
                    var uploader = new MediaUploader({
                        baseUrl: 'https://www.googleapis.com/upload/youtube/v3/videos',
                        file: file,
                        token: accessToken,
                        metadata: metaData,
                        params: {
                            part: Object.keys(metaData).join(',')
                        },
                        onError: function (data) {
                            deferred.reject(data);
                        },
                        onProgress: function (data) {
                            var time = Date.now();
                            var bytesUploaded = data.loaded;
                            var totalBytes = data.total;
                            var bytesPerSecond = bytesUploaded / ((time / start) / 1000);
                            var secondsRemaining = (totalBytes - bytesUploaded) / bytesPerSecond;
                            var completionPercentage = (bytesUploaded * 100) / totalBytes;
                            progress.bytesUploaded = bytesUploaded;
                            progress.totalBytes = totalBytes;
                            progress.bytesPerSecond = bytesPerSecond;
                            progress.secondsRemaining = secondsRemaining;
                            progress.completionPercentage = completionPercentage;
                        },
                        onComplete: function (data) {
                            console.log(JSON.parse(data));
                            deferred.resolve(JSON.parse(data));
                        }
                    });
                    var start = Date.now();
                    uploader.upload();
                })
                var promise = deferred.promise;
                promise.progress = progress;
                return promise;
            },
            loadIframeApi: function () {
                var tag = document.createElement('script');

                tag.src = "https://www.youtube.com/iframe_api";
                var firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

                $window.onYouTubeIframeAPIReady = function () {
                    $rootScope.$evalAsync(function () {
                        $rootScope.videoApiReady = true;
                    })
                }
            },
            registerId: function (id) {
                activeId = id;
            },
            closeVideo: function () {
                if (activeId !== undefined)
                    foundationApi.publish(activeId, 'close');
            },
            getPlaceholderCrops: function (id) {
                var base = 'https://i.ytimg.com/vi_webp/';
                return {
                    url: base + id + '/maxresdefault.webp',
                    width: 1280,
                    height: 720,
                    crops: [{
                        name: 'small',
                        url: base + id + '/mqdefault.webp',
                        width: 480,
                        height: 360
                    }, {
                        name: 'medium',
                        url: base + id + '/maxresdefault.webp',
                        width: 1280,
                        height: 720
                    }]
                };
            }
        };
        return services;
    }

    youtubeIdToEmbedUrl.$inject = ['$sce', '$location']
    function youtubeIdToEmbedUrl($sce, $location) {
        return function (val) {
            if (val === undefined)
                return '';
            var url = 'https://www.youtube.com/embed/' + val;
            if (arguments.length > 1) {
                for (var i = 1; i < arguments.length; i++) {
                    url += i === 1 ? '?' : '&';
                    url += arguments[i];
                }
                var fullUrl = $location.absUrl();
                var domain = fullUrl.substr(0, fullUrl.indexOf($location.path()));
                url += '&origin=' + encodeURIComponent(domain);
            }
            return $sce.trustAsResourceUrl(url);
        }
    }

    youtubeVideo.$inject = ['youtubeService', 'FoundationApi', 'FoundationMQ', '$filter', '$timeout', '$window'];
    function youtubeVideo(youtubeService, foundationApi, foundationMQ, $filter, $timeout, $window) {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: '/app/components/youtube/youtube.html',
            scope: {
                youtubeId: '@',
                placeholder: '=?',
                inline: '=?',
                correctPosition: '=?'
            },
            link: link
        };
        return directive;
        function link(scope, element, attrs) {
            var modal, win;
            function updateModalPosition() {
                if (modal !== undefined)
                    modal.css('transform', 'translateX(' + (scope.$parent.$index * win.width()) + 'px)');
            }
            if (attrs.correctPosition !== undefined) {
                $timeout(function () {
                    modal = element.find('.modal-overlay');
                    win = angular.element($window).on('resize.youtube' + scope.$parent.index, updateModalPosition)
                    scope.$on('$destroy', function () {
                        win.off('resize.youtube' + scope.$parent.index);
                    })
                })
            }
            scope.loading = true;
            if (scope.inline === undefined)
                scope.inline = false;
            var mq = foundationMQ.getMediaQueries();
            var isMedium = matchMedia(mq.medium);
            var size = isMedium.matches ? 'medium' : 'small';
            var player;
            isMedium.addListener(function (mq) {
                size = mq.matches ? 'medium' : 'small';
                scope.$evalAsync(updateBackground);
            });
            scope.$watch('youtubeId', function (youtubeId) {
                if (youtubeId !== undefined) {
                    if (scope.placeholder === undefined)
                        scope.placeholder = youtubeService.getPlaceholderCrops(youtubeId);
                    updateBackground();
                }
            });

            function updateBackground() {
                var background = $filter('getCropUrl')(scope.placeholder, size);
                var img = new Image();
                img.src = background;
                scope.loading = true;
                img.onload = function () {
                    scope.$evalAsync(function () {
                        scope.loading = false;
                        scope.background = {
                            backgroundImage: 'url("' + background + '")'
                        };
                    })
                }
                img.onerror = function () {
                    scope.$evalAsync(function () {
                        scope.loading = false;
                        scope.background = {
                            backgroundColor: '#200'
                        };
                    })
                }
            }

            scope.openVideo = function () {
                if (player == undefined) {
                    scope.loadVideo = true;
                    scope.loading = true;
                    $timeout(function () {
                        new YT.Player('player-' + scope.youtubeId, {
                            events: {
                                'onReady': function (event) {
                                    player = event.target;
                                    startVideo();
                                    scope.$evalAsync(function () {
                                        scope.loading = false;
                                    });
                                }
                            }
                        });
                    });
                }
                else {
                    startVideo();
                }
            }

            function startVideo() {
                var id = 'video-' + scope.youtubeId;
                youtubeService.registerId(id);
                updateModalPosition();
                foundationApi.publish(id, 'open');
                player.playVideo();
            }
            foundationApi.subscribe('video-' + scope.youtubeId, function (message) {
                if (message === 'close' && player !== undefined)
                    player.pauseVideo();
            })
        }
    }
})();